export var EcoType;

(function (EcoType) {
  EcoType["qywx"] = "qywx";
  EcoType["wx"] = "wx";
  EcoType["dingTalk"] = "dingTalk";
  EcoType["fs"] = "fs";
})(EcoType || (EcoType = {}));

;